import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

import DocumentAPI from './DocumentAPI';

class EmailTemplateAPI {

  static list = (success, failure) => {
    fetch(Config.app.link + 'api/email-template', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/email-template/' + id, new Header('GET'))
    .then(result => result.json().then(async res => {
     try {
      const body_json = await DocumentAPI.getPublicMediaUrl(res.body_json);
      try {
        res.design = JSON.parse(res.txt_body_json);
      } catch(err) { 
        console.log(err);
      }
      if(res.body_html) {
        const body_html = await DocumentAPI.getPublicMediaUrl(res.body_html);
        res.txt_body_html = await DocumentAPI.getText(body_html.url);
      }
      success(res);
     }
     catch(err){
      failure(err);
     }
    }))
    .catch(er =>failure(er));
  };

  static htmlRender = (body, success, failure) => {
    fetch(Config.app.link + 'api/email-template-object', new Header('post', body))
    .then(res => res.json())
    .then(data => success(data))
    .catch(er =>failure(er));
  }

  static save = (template, success, failure) => {
    new Promise(async (resolve, reject) => {
      const files = [ new Blob([template.txt_body_json], {type: 'text/json'}), 
        new Blob([template.txt_body_html], {type: 'text/html'})];
      const attr = [ 'body_json', 'body_html' ];

      const medias = [{ ref: 0, model_no: 32, model_id: 0, type: 'json', size: files[0].size },
        { ref: 1, model_no: 32, model_id: 0, type: 'html', size: files[1].size }];

      if(template.id === 0) {
        const resMedias = await new Promise(resolve => {
          fetch(Config.app.link + 'api/media/put-private', new Header('POST', medias))
          .then(res => {
            if(res.status === Const.Success200) { res.json().then(result => resolve(result)); }
            else { res.json().then(er => failure(er)); }
          }).catch(er => failure(er));
        });

        await new Promise(resolve => {
          fetch(resMedias[0].signed, { method: 'PUT', body: files[resMedias[0].ref] })
          .then(res => resolve(res));
        });
        template[attr[resMedias[0].ref]] = resMedias[0].id;

        await new Promise(resolve => {
          fetch(resMedias[1].signed, { method: 'PUT', body: files[resMedias[1].ref] })
          .then(res => resolve(res));
        });
        template[attr[resMedias[1].ref]] = resMedias[1].id;
        template.txt_body_json = '';
        template.txt_body_html = '';
      } else {
        let resMe = await new Promise(resolve => {
          fetch(Config.app.link + 'api/media/put-private/' + template.body_json,
            new Header('POST', medias[0]))
          .then(res => res.json().then(result => resolve(result))).catch(er => failure(er));
        });
        await new Promise(resolve => {
          fetch(resMe.signed, { method: 'PUT', body: files[0] }).then(res => resolve(res));
        });

        resMe = await new Promise(resolve => {
          fetch(Config.app.link + 'api/media/put-private/' + template.body_html,
            new Header('POST', medias[1]))
          .then(res => res.json().then(result => resolve(result))).catch(er => failure(er));
        });
        await new Promise(resolve => fetch(resMe.signed, { method: 'PUT', body: files[1] })
          .then(res => resolve(res)));
        template.txt_body_json = '';
        template.txt_body_html = '';
      }

      template.body_design = '';
      template.design = '';
      
      fetch(Config.app.link + 'api/email-template', new Header('POST', template))
        .then(res => resolve(res)).catch(er => reject(er));
    })
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));;
  }  

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/email-template/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default EmailTemplateAPI;